<template>
  <div>
  <body>
    <div :class="`new-form ${page}`">
      <div class="new-form-container">
        <div class="new-form-wrapper">
          <router-view/>
        </div>
      </div>
    </div>

  </body>
  </div>
</template>

<style type="text/css">
    @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
    body { background: transparent; }

    * {
      font-family: 'Basic',Helvetica,Arial,Lucida,sans-serif;
    }

    .new-form {
      background: transparent;
    }

    .new-form * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    .new-form-container {
      max-width: 100%;
      margin: 0 auto;
      padding: 20px;
    }

    .new-form-wrapper {
      position: relative;
      padding: 20px;
      box-shadow: 0 1rem 3rem rgba(0,0,0,.175);
      border: 1px solid rgba(0,0,0,.125);
      border-radius: 0.25rem;
      background: white;
    }

    .new-form-row + .new-form-row{
      margin-top: 20px;
    }

    .new-form-legend {
      font-family: Montserrat,sans-serif;
      font-size: 1.75rem;
      font-weight: 600;
      line-height: 1.2em;
      text-align: center;
      color: #212529;
    }

    .new-form-legend + * {
      margin-top: 8px;
    }

    .new-form-text {
      font-family: Montserrat,sans-serif;
      font-size: 1.15rem;
      line-height: 1.2em;
      color: #212529;
    }

    .new-form-text + * {
      margin-top: 8px;
    }

    .new-form-group-radio {
      display: flex;
      align-items: stretch;
      justify-content: center;
      flex-wrap: wrap;
      width: 100%;
    }

    .new-form-radio {
      flex: 1;
    }

    .new-form-radio input {
      position: absolute;
      opacity: 0;
      visibility: hidden;
    }

    .new-form-radio input:checked + label {
      color: white;
      background: #590a7f;
    }

    .new-form-radio label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      font-weight: bold;
      text-align: center;
      color: #590a7f;
      padding: 20px;
      border: 1px solid #590a7f;
      cursor: pointer;
    }

    .new-form-input input,
    .new-form-input select,
    .new-form-input textarea {
      display: block;
      width: 100%;
      padding: 16px 20px;
      border: 1px solid rgba(0,0,0,.125);
      color: #212529 !important;
      border-radius: 0.25rem;
    }

    .new-form-error {
      display: block;
      margin-top: 4px;
      color: red;
    }

    .new-form-controls {
      display: flex;
      align-items: stretch;
      justify-content: center;
      gap: 8px;
      margin-top: 20px;
    }

    .new-form-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      font-weight: bold;
      padding: 10px 20px;
      border: 1px solid;
      border-radius: 0.25rem;
      cursor: pointer;
    }

    .new-form-button.new-form-button-primary {
      color: white;
      background: #590a7f;
    }

    .new-form-button.new-form-button-default {
      color: #212529;
      background: white;
    }

    .new-form-loading {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(255,255,255,0.5);
    }

    .new-form-loading::before {
      content: '';
      display: block;
      position: absolute;
      width: 28px;
      height: 28px;
      top: calc(50% - 14px);
      left: calc(50% - 14px);
      border-radius: 100%;
      border: 2px solid transparent;
      border-top-color: #590a7f;
      border-bottom-color: #590a7f;
      animation: loading 1s ease-in-out infinite;
    }

    @keyframes loading {
      to {
        transform: rotate(360deg)
      }
    }
</style>

<script>
import { setupVue } from '../views/microfrontend/setupVue';
setupVue();

export default {
  name: 'DefaultMicroFrontend',
  mounted () {
    this.page = this.$route.name;
  },
  data () {
    return {
      page: ''
    };
  }
};
</script>
